const formatDateForInputWIB = (date: string) => {
  if (!date) return '';

  const localDate = new Date(date);
  localDate.setHours(localDate.getHours() + 7);
  return localDate.toISOString().split('T')[0];
};

export default formatDateForInputWIB;
